var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIyhQuotesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.45 51.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a31e23;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.15,37.39c0-4.18,1.28-7.87,4.66-14.94l10.12-21h13L22.35,26.47a12.8,12.8,0,0,1,5.94,11.08c0,7.39-6.1,12.85-13.65,12.85-7.71,0-13.49-5.46-13.49-13m32.93,0c0-4.18,1.28-7.87,4.65-14.94L49,1.41H62L55.28,26.47a12.8,12.8,0,0,1,5.94,11.08c0,7.39-5.94,12.85-13.65,12.85s-13.49-5.46-13.49-13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIyhQuotesIcon);
export default __webpack_public_path__ + "static/media/iyh_quotes-icon.52607e337c8357e7cf2999b47f2dd671.svg";
export { ForwardRef as ReactComponent };